﻿import { useState, useEffect, useRef } from "react";
import {
    Table,
    Input,
    Space,
    Spin,
    Modal,
    Select,
    Drawer,
    Form,
} from "antd";
import { message } from "../../components/antdMessageBridge";
import { CloseCircleOutlined } from "@ant-design/icons";
import CommonObj from "../../CommonObj";
import { useLocation, useNavigate } from "react-router-dom";
import { getUTCDate } from "../../components/utcDate";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import "../manifest-creation/manifestcreation.css";
import { useAuth } from "../../auth/AuthContext";
import { Html5QrcodeScanType } from "html5-qrcode";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import { Option } from "antd/es/mentions";
import "./recyclebid-confirmation.css";
import TextArea from "antd/es/input/TextArea";
import regexService, {
    removeSpaces,
} from "../../components/commonregex/regexService";
import CuttingIcon from "../../assets/img/svg/xrecyclebidcutting.svg?react";
import ScanningIcon from "../../assets/img/svg/xrecyclebidscanning.svg?react";
import QCIcon from "../../assets/img/svg/xqctitleicon.svg?react";
import NonRecyclableBidPopup from "./nonRecyclableBid-popup";
import validationService from "../../components/commonvalidation/validationService";
import { showManualEntryDisabledWarning } from "../../components/commonvalidation/manualEntryWarning";
import useFieldPermissions from "../../hooks/useFieldPermissions";

const RecycleBidConfirmation = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [form1] = Form.useForm();
    const [form2] = Form.useForm();
    const { isReadOnly } = useFieldPermissions("bidConfirmation");

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [startTime, setStartTime] = useState("");
    const [selectedBID, setSelectedBID] = useState("");
    const [rejectionOptions, setRejectOptions] = useState([]);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [selectedItems, setSelectedItems] = useState({});
    const [status, setStatus] = useState(null);
    const [showIcons, setShowIcons] = useState(false);
    const [bsnVisible, setBsnVisible] = useState(false);
    const [clickOf, setClickOf] = useState("");//("Client Rejected"TBI Status

    const [form, setForm] = useState({
        bid: "",
        rackId: "",
    });
    const { roleUserId } = useAuth();
    const [sortedInfo, setSortedInfo] = useState({});
    const [searchFilters, setsearchFilters] = useState({});
    const { accessToken } = useAuthToken();
    const [regexLoaded, setRegexLoaded] = useState(false);
    const [drawerVisible, setDrawerVisible] = useState(false);

    const isProcessingRef = useRef(false);
    const lastRackIdKeyTimeRef = useRef(0);
    const clearRackIdTimerRef = useRef(null);
    const lastBidKeyTimeRef = useRef(0);
    const clearBidTimerRef = useRef(null);
    const lastPopupRackShelfKeyTimeRef = useRef(0);
    const clearPopupRackShelfTimerRef = useRef(null);

    useEffect(() => {
        return () => {
            clearTimeout(clearRackIdTimerRef.current);
            clearTimeout(clearBidTimerRef.current);
            clearTimeout(clearPopupRackShelfTimerRef.current);
        };
    }, []);

    const location = useLocation();
    const rackKey = location?.state?.key || {};
    const rackKeyClient = location?.state || {};

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const [activeScanner, setActiveScanner] = useState(null);
    const [decodedResults, setDecodedResults] = useState([]);


    const handleClear = () => {
        setSelectedRecord(null);
        form1.resetFields();
        form2.resetFields();
    };
    useEffect(() => {
        const shwIcon = sessionStorage.getItem("showIcons") === "true";
        const saved = sessionStorage.getItem("selectedItems");
        const selectedItems = saved ? JSON.parse(saved) : {};
        if (shwIcon === true) {
            setShowIcons(true);
            setSelectedItems(selectedItems)
        }
    }, []);

    const handleEdit = (key, string) => {
        navigate("/self-fixed", { state: { key, string } });
    };

    useEffect(() => {
        return () => {
            Modal.destroyAll();
        };
    }, []);
    function filterUniqueScans(results) {
        const filteredResults = [];
        if (results.length === 0) {
            return filteredResults;
        }
        filteredResults.push(results[0]);
        for (let i = 1; i < results.length; ++i) {
            if (results[i].decodedText !== results[i - 1].decodedText) {
                filteredResults.push(results[i]);
            }
        }
        return filteredResults;
    }


    useEffect(() => {
        const uniqueResults = filterUniqueScans(decodedResults);
        if (uniqueResults.length > 0 && activeScanner) {
            const latestResult = uniqueResults[uniqueResults.length - 1];
            const scannedValue = latestResult.decodedText.trim();
            switch (activeScanner) {
                case "BID":
                    setForm((prev) => ({ ...prev, bid: scannedValue }));
                    break;
                case "Recycle Bin ID":
                    setForm((prev) => ({ ...prev, rackId: scannedValue }));
                    break;
                case "Rack & Shelf ID":
                    form1.setFieldsValue({ rackAndShelf: scannedValue });
                    break;
                default:
                    break;
            }
            setActiveScanner(null);
            setDecodedResults([]);
        }
    }, [decodedResults, activeScanner]);

    const onNewScanResult = (decodedText, decodedResult) => {
        setDecodedResults((prev) => [...prev, decodedResult]);
    };
    const showRejectModal = (record) => {
        setStatus(record?.status);
        fetchRejectionData();
        setSelectedRecord(record.bid);
        setSelectedRowKeys([record.bid]);
        setDrawerVisible(true);
    };
    const columns = [
        {
            title: "BID No",
            dataIndex: "bid",
            key: "bid",
            width: 200,
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            align: "center",
            width: 200,
        },
        {
            title: "Confirmation",
            dataIndex: "confirmation",
            key: "confirmation",
            width: 200,
            align: "center",
            render: (text) => (
                <div style={{ justifyItems: "center" }}>
                    {" "}
                    {text == "Confirmed" ? (
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="9"
                                cy="9"
                                r="7.5"
                                fill="#CAFFD8"
                                stroke="#5BCD7A"
                                stroke-width="1.2"
                            />
                            <path
                                d="M6.375 9.375L7.875 10.875L11.625 7.125"
                                stroke="#229100"
                                stroke-width="1.2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    ) : (
                        text
                    )}
                </div>
            ),
        },
        {
            title: "Recycle Bin",
            dataIndex: "recycleBin",
            key: "recycleBin",
            width: 200,
            render: (text) => <span> {text} </span>,
        },
        {
            title: "Action",
            width: 200,
            dataIndex: "status",
            key: "status",
            align: "center",
            render: (text, record) => {
                const { status, bid } = record;

                const canShowActions = showIcons && selectedItems[bid] && status;
                if (!canShowActions) return null;

                const isRejected = status.includes("Client Review - Reject");

                // const isExcluded = ["WIP", "TBI", "Ready to Recycle"].some((s) =>
                //   status.includes(s),
                // );
                // if (isExcluded) return null;

                return (
                    <div >
                        <Space size="middle" title="Rework">
                            <button type="button" onClick={() => showRejectModal(record)}>
                                {isRejected && (
                                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none">
                                        <circle
                                            opacity="0.5"
                                            cx="12"
                                            cy="12"
                                            r="8"
                                            stroke="#002449"
                                            strokeWidth="1.2"
                                        />
                                        <path
                                            d="M15.182 9.37083L14.8284 9.0089C13.2663 7.40976 10.7337 7.40976 9.17157 9.0089C7.60948 10.608 7.60948 13.2007 9.17157 14.7999C10.7337 16.399 13.2663 16.399 14.8284 14.7999C15.7368 13.8699 16.117 12.604 15.9688 11.3928M15.182 9.37083H13.0607M15.182 9.37083V7.19922"
                                            stroke="#002449"
                                            strokeWidth="1.2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                )}
                            </button>
                        </Space>

                        {isRejected && (
                            <Space
                                size="middle"
                                style={{ marginLeft: "20px" }}
                                title="Self Fix"
                            >
                                <button
                                    type="button"
                                    onClick={() => handleEdit(bid, "recycle")}
                                >
                                    <svg
                                        width="24"
                                        height="22"
                                        viewBox="0 0 21 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="9"
                                            cy="4.5"
                                            r="3"
                                            stroke="#002449"
                                            stroke-width="1.2"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M11.25 9.99533C10.5552 9.83712 9.79568 9.75 9 9.75C5.68629 9.75 3 11.261 3 13.125C3 14.989 3 16.5 9 16.5C13.2656 16.5 14.4986 15.7363 14.8551 14.625"
                                            stroke="#002449"
                                            stroke-width="1.2"
                                        />
                                        <rect
                                            x="9"
                                            y="9"
                                            width="8.25"
                                            height="8.25"
                                            rx="4.125"
                                            fill="white"
                                        />
                                        <g clip-path="url(#clip0_5244_39975)">
                                            <circle cx="14" cy="13" r="1" stroke="#002449" />
                                            <path
                                                d="M14.5867 9.71774C14.4641 9.66699 14.3088 9.66699 13.9982 9.66699C13.6876 9.66699 13.5323 9.66699 13.4098 9.71774C13.2464 9.7854 13.1166 9.91518 13.049 10.0785C13.0181 10.1531 13.006 10.2398 13.0012 10.3663C12.9943 10.5522 12.899 10.7243 12.7379 10.8173C12.5768 10.9103 12.3801 10.9068 12.2156 10.8199C12.1037 10.7608 12.0225 10.7279 11.9425 10.7173C11.7672 10.6943 11.5899 10.7418 11.4497 10.8494C11.3445 10.9301 11.2668 11.0646 11.1115 11.3336C10.9562 11.6026 10.8785 11.7372 10.8612 11.8686C10.8381 12.0439 10.8856 12.2212 10.9933 12.3615C11.0424 12.4255 11.1114 12.4793 11.2186 12.5467C11.3761 12.6457 11.4775 12.8143 11.4775 13.0003C11.4775 13.1864 11.3761 13.355 11.2186 13.4539C11.1114 13.5213 11.0424 13.5751 10.9932 13.6391C10.8856 13.7794 10.8381 13.9567 10.8612 14.132C10.8785 14.2635 10.9561 14.398 11.1115 14.667C11.2668 14.936 11.3444 15.0705 11.4496 15.1512C11.5899 15.2589 11.7672 15.3064 11.9425 15.2833C12.0225 15.2728 12.1036 15.2399 12.2156 15.1807C12.38 15.0938 12.5767 15.0903 12.7378 15.1833C12.899 15.2764 12.9943 15.4484 13.0012 15.6343C13.006 15.7608 13.0181 15.8475 13.049 15.9221C13.1166 16.0855 13.2464 16.2152 13.4098 16.2829C13.5323 16.3337 13.6876 16.3337 13.9982 16.3337C14.3088 16.3337 14.4641 16.3337 14.5867 16.2829C14.75 16.2152 14.8798 16.0855 14.9475 15.9221C14.9783 15.8475 14.9904 15.7608 14.9952 15.6343C15.0021 15.4484 15.0974 15.2764 15.2585 15.1833C15.4196 15.0903 15.6164 15.0938 15.7808 15.1807C15.8927 15.2399 15.9739 15.2727 16.0539 15.2833C16.2292 15.3064 16.4065 15.2588 16.5467 15.1512C16.652 15.0705 16.7296 14.936 16.8849 14.667C17.0402 14.398 17.1179 14.2635 17.1352 14.132C17.1583 13.9567 17.1108 13.7794 17.0031 13.6391C16.954 13.5751 16.885 13.5213 16.7778 13.4539C16.6203 13.3549 16.5189 13.1863 16.5189 13.0003C16.5189 12.8143 16.6203 12.6457 16.7778 12.5467C16.885 12.4794 16.954 12.4255 17.0032 12.3615C17.1108 12.2212 17.1583 12.0439 17.1352 11.8686C17.1179 11.7372 17.0403 11.6027 16.885 11.3337C16.7296 11.0646 16.652 10.9301 16.5468 10.8494C16.4065 10.7418 16.2292 10.6943 16.0539 10.7174C15.9739 10.7279 15.8928 10.7608 15.7809 10.8199C15.6164 10.9069 15.4197 10.9103 15.2586 10.8173C15.0975 10.7243 15.0021 10.5522 14.9952 10.3663C14.9904 10.2398 14.9783 10.1531 14.9475 10.0785C14.8798 9.91518 14.75 9.7854 14.5867 9.71774Z"
                                                stroke="#002449"
                                            />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_5244_39975">
                                                <rect
                                                    x="10"
                                                    y="9"
                                                    width="8"
                                                    height="8"
                                                    rx="4"
                                                    fill="white"
                                                />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </button>
                            </Space>
                        )}
                    </div>
                );
            },
        },
    ];

    const getRowClassName = (record, index) => {
        return index % 2 === 0 ? "odd-row" : "even-row";
    };

    const handleTableChange = (newPagination, filters, sorter) => {
        const normalizeFilters = {};
        Object.keys(filters).forEach((key) => {
            if (filters[key] && filters[key].length > 0) {
                normalizeFilters[key] = filters[key][0];
            }
        });

        setsearchFilters(normalizeFilters);
        setSortedInfo(sorter);

        setPagination((prev) => ({
            ...prev,
            current: newPagination.current,
            pageSize: newPagination.pageSize,
        }));

        fetchData();
    };

    const fetchData = async () => {
        const isEmptyObject = (obj) => Object.keys(obj).length === 0;
        const payload = {
            rack: !isEmptyObject(rackKey) ? rackKey : rackKeyClient,
        };
        setLoading(true);
        try {
            const myHeaders = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
            };

            const response = await fetch(CommonObj.Endpoints.GetRackBids, {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();

            if (data?.error === "No Ready to Recycle Details found") {
                setData([]);
                message.warning("The scanned Rack ID does not exist");
            } else {
                const newData = Array.isArray(data.output)
                    ? [...data.output]
                    : [data.output];

                setData(data);
                const total = data[0]?.totalRows || 0;
                setPagination((prev) => ({
                    ...prev,
                    total,
                }));
            }
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const SubmitBidRecycle = async () => {
        const bidValue = form?.bid?.trim() || "";
        const rackIdValue = form?.rackId?.trim() || "";
        const filteredRecord = data.find((x) => x.bid === bidValue);
        //const regex = /^BID[A-Za-z0-9\-]{13}$/;

        //if (bidValue && !regex.test(bidValue)) {
        //  return message.error("Invalid BID");
        //}

        const bidError = validationService.validateBid(form.bid);
        if (bidError) {
            setForm((prev) => ({ ...prev, bid: "" }));
            return message.error(bidError);
        }


        const payload = {
            bid: bidValue,
            recycleBin: rackIdValue,
            rack: rackKey ? rackKey : rackKeyClient,
        };

        if (!rackIdValue) {
            message.error("Recycle Bin cannot be empty");
            return;
        }

        if (regexLoaded) {
            const recycleBinError = validationService.validateRecycleBin(rackIdValue);
            if (recycleBinError) {
                message.error(recycleBinError);
                return;
            }
        }

        try {
            const myHeaders = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
            };

            const response = await fetch(CommonObj.Endpoints.SubmitRecycleId, {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(payload),
            });

            let responseData;
            try {
                responseData = await response.json();
            } catch (parseError) {
                responseData = {};
            }

            if (!response.ok) {
                const apiErrorMessage =
                    responseData?.error || responseData?.message || "Network response was not ok";
                message.error(apiErrorMessage);
                return;
            }

            if (responseData?.error) {
                message.error(responseData.error);
                return;
            }

            if (responseData?.status === false) {
                message.error(responseData?.message || "This GL# has already been shipped. Please enter a different GL#.");
                return;
            }

            setForm({ bid: "", rackId: form.rackId });
            if (responseData.message.includes("Error: BID not part of the Rack")) {
                message.error("BID not part of the Rack");
                return
            }
            if (responseData.message.includes("Success") && filteredRecord?.status?.includes("Ready to Recycle")) {
                form1.resetFields();
                setBsnVisible(true);
                setClickOf("Ready Status");
            }
            if (bidValue.trim() !== "") {
                setSelectedBID(bidValue);
                setSelectedRecord(bidValue);
                console.log("filteredRecord", filteredRecord);

                if (filteredRecord?.status.includes("Client Review - Reject")) {
                    form1.resetFields();
                    setBsnVisible(true);
                    setClickOf("Client Rejected");
                    return;
                } else if (!filteredRecord?.status?.includes("Ready to Recycle")) {
                    form1.resetFields();
                    setBsnVisible(true);
                    setClickOf("TBI Status");
                    return;
                }
            }
            await fetchData();
        } catch (err) {
            console.error("Error submitting bid:", err);
            message.error(err?.message || "Failed to submit the bid for recycling");
        }
    };
    const SubmitRackShelf = async (key) => {
        let bids;
        bids = selectedRecord || selectedBID;
        const formData = new FormData();
        formData.append("BID", bids);
        formData.append("RackShelf", key?.rackAndShelf);
        formData.append("UserId", roleUserId);

        try {
            const response = await fetch(CommonObj.Endpoints.BookRackUpdateAsync, {
                method: "POST",
                mode: "cors",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.json();
            message.success("Item moved to new Rack Shelf and removed from this Rack.");
            setSelectedRowKeys();
            setBsnVisible(false);
            setForm({ bid: "", rackId: form.rackId });
            form1.resetFields();
            fetchData();
            if (data.message === "") {
                return { valid: true, data: data };
            } else if (data.message) {
                return { valid: false, message: data.message || "BID not found" };
            }
        } catch (err) {
            return {
                valid: false,
                message: "Something went wrong!. Please contact your administrator",
            };
        }
    };
    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
                await validationService.fetchRegexData(accessToken);
                setRegexLoaded(true);
            } catch (error) {
                console.error("Failed to load regex patterns", error);
            }
        };

        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);
    useEffect(() => {
        fetchData();
    }, []);
    useEffect(() => {
        setStartTime("");
    }, []);

    if (loading) {
        return (
            <Spin size="large" style={{ margin: "20px auto" }} />
        );
    }

    const validateRackShelf = (_, value) => {
        if (!value?.trim()) {
            return Promise.reject(new Error("Rack and Shelf is required."));
        }

        const bidValue = form?.bid?.trim() || selectedRecord || selectedBID || "";
        const filteredRecord = data.find((x) => x.bid === bidValue);
        const normalizedInput = removeSpaces(value).toLowerCase();
        const normalizedExisting = removeSpaces(filteredRecord?.rackandShelf || "").toLowerCase();

        if (normalizedInput.includes(normalizedExisting)) {
            return Promise.reject(
                new Error("The Rack Shelf scanned must not be the same as current Rack Shelf.")
            );
        }
        if (regexLoaded) {
            const validation = regexService.validateRackShelf(value.trim());
            if (!validation.isValid) {
                return Promise.reject(new Error("Input format invalid: No matching pattern found."));
            }
        }

        return Promise.resolve();
    };

    function cusfun(e) {
        e.preventDefault();
    }
    const fetchRejectionData = async () => {
        try {
            const myHeaders = {
                Authorization: `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
                "Content-Type": "application/json",
            };
            const response = await fetch(
                CommonObj.Endpoints.GetClientRejectionTypes,
                {
                    method: "POST",
                    headers: myHeaders,
                }
            );

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const result = await response.json();
            const books = Array.isArray(result) ? result : [result];
            const formattedData = books.map((item) => ({
                ...item,
                key: item.referenceId,
            }));
            setRejectOptions(formattedData);
        } catch (err) {
            setError(err);
        }
    };

    const handleCancel = () => {
        setDrawerVisible(false);
        setSelectedRecord(null);
        form1.resetFields();
        form2.resetFields();
    };
    const handleIcon = (icon) => {
        if (icon == 3) {
            return <CuttingIcon />;
        } else if (icon == 4) {
            return <ScanningIcon />;
        } else {
            return <QCIcon />;
        }
    };
    const handleClientQueueReject = async (key) => {
        const commaSeparatedIds = selectedRowKeys.join(",");
        let bids;

        if (commaSeparatedIds) {
            bids = commaSeparatedIds;
        } else {
            bids = selectedRecord.bidNo;
        }
        try {
            const loadingKey = "rejecting";
            message.loading({ content: "Reworking BID...", key: loadingKey });
            const endUTCTime = getUTCDate();
            const payload = {
                biDs: bids,
                userId: roleUserId,
                startTime: startTime,
                endTime: endUTCTime?.UTCDate,
                rejectionType: key.rejectionType,
                rejectionReason: key.rejectionReason,
                rackShelf: key.rackAndShelf,
            };

            const myHeaders = {
                Authorization: `Bearer ${accessToken}`,
                "X-CSRF-Token": encryptTimestamp(),
                "Content-Type": "application/json",
            };

            const response = await fetch(CommonObj.Endpoints.ClientQueueReject, {
                method: "POST",
                headers: myHeaders,
                body: JSON.stringify(payload),
            });

            if (response) {
                fetchData();

                const startUTCTime = getUTCDate();
                setStartTime(startUTCTime?.UTCDate);
                message.success({
                    content: "Book(s) has been sent for rework successfully!",
                    key: loadingKey,
                    duration: 2,
                });
                handleCancel();
                setSelectedRowKeys();
            } else {
                message.error({
                    content: "Failed to Rework BID.",
                    key: loadingKey,
                    duration: 2,
                });
            }
        } catch (error) {
            console.error("API Error:", error);
            message.error({
                content: "An error occurred. Please try again.",
                key: "rejecting",
                duration: 2,
            });
        }
    };

    const reworkLabel = (
        <span>
            Rework Request For
            <span style={{ color: '#42769a' }}> {selectedRecord}</span>
            <span style={{ color: '#F26469' }}> {selectedRowKeys?.length} Selected</span>
        </span>
    );
    const handleClosePopup = () => {
        setClickOf("");
        setForm({ bid: "", rackId: form.rackId });
        setBsnVisible(false);
        setSelectedItems(prevItems => ({
            ...prevItems,
            [selectedBID]: false,
        }));
        form1.resetFields();
        setSelectedRecord(null);
        setSelectedBID("");
    }

    const handleOkClick = () => {
        setBsnVisible(false);
        setShowIcons(true);
        setClickOf("");
        const updatedItems = {
            ...selectedItems,
            [selectedBID]: true
        };
        setForm({ bid: "", rackId: form.rackId });
        setSelectedItems(updatedItems);


        sessionStorage.setItem("showIcons", true);
        sessionStorage.setItem("selectedItems", JSON.stringify(updatedItems));

    }

    const tbiStatusPopupContent = "This BID is not approved for recycling. Scan a Rack Shelf to move this item and clear it from the list";
    const clientRejectBookPopupContent = "This book has been rejected by the client and is not eligible for recycling. To resolve this, please use the Action Icon in the list to select either 'Self-Fixed' or 'Rework'."
    const readyToRecyclePopupContent = "Book is confirmed & assigned with the Recycle Bin ID"
    const popupConfigs = {
        "TBI Status": {
            title: "Item Not Ready for Recycle",
            content: tbiStatusPopupContent,
            clickFor: "TBI Status"
        },
        "Client Rejected": {
            title: "Client Rejected Book",
            content: clientRejectBookPopupContent,
            clickFor: "Client Rejected"
        },
        "Ready Status": { // Your third condition
            title: "Successfully Assigned Recycle Bin ID",
            content: readyToRecyclePopupContent,
            clickFor: "Ready Status"
        }
    };
    const currentConfig = popupConfigs[clickOf] || popupConfigs["TBI Status"];
    return (
        <>
            <NonRecyclableBidPopup
                title={currentConfig.title}
                open={bsnVisible}
                className="recycle-manifest-model stop-modal"
                subContent={currentConfig.content}
                clickFor={currentConfig.clickFor}
                onOKClick={handleOkClick}
                handleCloseHandler={handleClosePopup}
                rackselfInput={<Form
                    form={form1}
                    layout="vertical"
                    onFinish={SubmitRackShelf}
                    initialValues={""}
                > <span className="form-required-rack">*</span>
                    <div className="book-page-form-scan-rack-container modal-scan-rack  bgColor span2column">
                        <Form.Item
                            name="rackAndShelf"
                            rules={[
                                {
                                    validator: validateRackShelf,
                                },
                            ]}
                            className="book-page-form-scan-rack-button"
                        >
                      <Input placeholder={(isReadOnly("popupRackShelf") ? "Scan " : "Enter / Scan ")+"New Rack Shelf"}
                        onKeyDown={(e) => {
                            if (!isReadOnly("popupRackShelf")) {
                                return;
                            }

                            // Let native copy/paste behave normally (no custom clipboard handling).
                            const isCopyOrPasteShortcut =
                                (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
                            if (isCopyOrPasteShortcut) {
                                return;
                            }

                            if (e.key === 'Enter' || e.key === 'Tab') {
                                return;
                            }

                            const currentTime = Date.now();
                            const timeDiff = currentTime - lastPopupRackShelfKeyTimeRef.current;
                            lastPopupRackShelfKeyTimeRef.current = currentTime;

                            // A physical scanner sends characters within a few milliseconds of each
                            // other, so only block keystrokes that arrive slowly (manual typing).
                            // The very first keystroke (field currently empty) is always let through
                            // so a scan burst never loses its first character.
                            const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
                            if (!isSlowManualKeystroke) {
                                return;
                            }

                            e.preventDefault();
                            form1.setFieldsValue({ rackAndShelf: '' });

                            clearTimeout(clearPopupRackShelfTimerRef.current);
                            clearPopupRackShelfTimerRef.current = setTimeout(() => {
                                showManualEntryDisabledWarning();
                            }, 300);
                        }}></Input>
                        </Form.Item>
                        <Form.Item name="submit" hidden></Form.Item>
                        <button
                            className="book-page-form-scan-rack-button-icon"
                            htmlType="submit"
                            onClick={(event) => {
                                setDecodedResults([]);
                                setActiveScanner("Rack & Shelf ID");
                                cusfun(event);
                            }}
                            data-track="bidConfirmation-popup-bid-popup-scanner"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle
                                    cx="12"
                                    cy="13"
                                    r="3"
                                    stroke="#1C274C"
                                    strokeWidth="1.5"
                                />
                                <path
                                    opacity="0.5"
                                    d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                    stroke="#1C274C"
                                    strokeWidth="1.5"
                                />
                                <path
                                    d="M18 10H17.5"
                                    stroke="#1C274C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                                <path
                                    opacity="0.5"
                                    d="M14.5 3.5H9.5"
                                    stroke="#1C274C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                            <svg
                                width="20"
                                height="18"
                                viewBox="0 0 20 18"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M6.00098 1C6.00098 0.447715 6.41425 0 6.92405 0H13.0779C13.5877 0 14.001 0.447715 14.001 1C14.001 1.55228 13.5877 2 13.0779 2H6.92405C6.41425 2 6.00098 1.55228 6.00098 1Z"
                                    fill="url(#paint0_linear_2146_40101)"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.77875 18H12.2232C15.3442 18 16.9047 18 18.0257 17.2777C18.511 16.965 18.9277 16.5632 19.252 16.0953C20.001 15.0143 20.001 13.5095 20.001 10.4999C20.001 7.49027 20.0008 5.9857 19.2518 4.90473C18.9275 4.43676 18.5109 4.03497 18.0256 3.72228C16.9046 3 15.3441 3 12.223 3H7.77859C4.65756 3 3.09705 3 1.97605 3.72228C1.49077 4.03497 1.0741 4.43676 0.749835 4.90473C0.000976503 5.98547 0.000976526 7.48961 0.000976563 10.4979L0.000976563 10.4999C0.000976563 13.5095 0.000976622 15.0143 0.750001 16.0953C1.07426 16.5632 1.49093 16.965 1.97622 17.2777C3.09721 18 4.65773 18 7.77875 18ZM5.83431 10.4999C5.83431 8.28085 7.69979 6.48196 10.001 6.48196C12.3022 6.48196 14.1676 8.28085 14.1676 10.4999C14.1676 12.7189 12.3022 14.5178 10.001 14.5178C7.69979 14.5178 5.83431 12.7189 5.83431 10.4999ZM7.50098 10.4999C7.50098 9.16846 8.62027 8.08913 10.001 8.08913C11.3817 8.08913 12.501 9.16846 12.501 10.4999C12.501 11.8313 11.3817 12.9106 10.001 12.9106C8.62027 12.9106 7.50098 11.8313 7.50098 10.4999ZM16.1121 6.48196C15.6519 6.48196 15.2788 6.84174 15.2788 7.28554C15.2788 7.72935 15.6519 8.08913 16.1121 8.08913H16.6676C17.1279 8.08913 17.501 7.72935 17.501 7.28554C17.501 6.84174 17.1279 6.48196 16.6676 6.48196H16.1121Z"
                                    fill="url(#paint1_linear_2146_40101)"
                                />
                                <defs>
                                    <linearGradient
                                        id="paint0_linear_2146_40101"
                                        x1="20.601"
                                        y1="8.95028"
                                        x2="-0.0170404"
                                        y2="11.3301"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#033D9B" />
                                        <stop offset="1" stopColor="#29ACD5" />
                                    </linearGradient>
                                    <linearGradient
                                        id="paint1_linear_2146_40101"
                                        x1="20.601"
                                        y1="8.95028"
                                        x2="-0.0170404"
                                        y2="11.3301"
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#033D9B" />
                                        <stop offset="1" stopColor="#29ACD5" />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </button>
                        <span className="error-msg-rad"></span>
                    </div>
                    <div className="modal-footer">
                        <Form.Item className="model-action-container">
                            { }
                            <div className="book-page-buttons-container" style={{ display: "flex", gap: "5px", justifyContent: "center" }} >
                                <button
                                    style={{ margin: "10px", borderColor: "#29acd5", width: "120px", color: "#29acd5" }}
                                    className="modal-cancel-button"
                                    type="button"
                                    onClick={handleClosePopup}
                                >
                                    Cancel
                                </button>
                                <button
                                    style={{ margin: "10px", width: "120px" }}
                                    className="accept-button"
                                    htmlType="submit"
                                    onClick={() => SubmitRackShelf}
                                >
                                    Submit
                                </button>
                            </div>

                        </Form.Item>
                    </div>
                </Form>}
            />
            <Drawer
                title={<span>{status && !status.includes("Client Review - Reject") ? "Submit RackShelf" : reworkLabel}</span>}
                open={drawerVisible}
                onCancel={handleCancel}
                onClose={handleCancel}
                footer={null}
                closeIcon={<CloseCircleOutlined />}
                className="story-slider slider-with-footer"
                width={540}
            >
                <div className="modal-body">
                    {status && status.includes("Client Review - Reject") && (
                        <Form
                            form={form1}
                            layout="vertical"
                            onFinish={handleClientQueueReject}
                            initialValues={""}
                        >
                            <Form.Item name="bidId" label="Bid ID" hidden>
                                <Input />
                            </Form.Item>
                            <Form.Item
                                name="rejectionReason"
                                label="Rework Reason"
                                rules={[
                                    { required: true, message: "Please provide a Reason!" },
                                ]}
                                className="rejection-reason-slider"
                            >
                                <TextArea rows={3} className="book-page-form-input-textarea" />
                            </Form.Item>
                            <Form.Item
                                name="rejectionType"
                                label="Move To Station"
                                rules={[
                                    { required: true, message: "Please select a Station!" },
                                ]}
                                className="rejection-reason-slider"
                            >
                                <Select placeholder="Select a Station">
                                    {rejectionOptions.map((option) => (
                                        <Option key={option.id} value={option.id}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "7px",
                                                }}
                                            >
                                                {handleIcon(option.id)} {option.name}
                                            </div>
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <label className="form-label">
                                Scan Rack Shelf<span className="form-required-rack">*</span>
                            </label>
                            <div className="book-page-form-scan-rack-container modal-scan-rack  bgColor span2column">
                                <Form.Item
                                    name="rackAndShelf"
                                    rules={[
                                        {
                                            validator: validateRackShelf,
                                        },
                                    ]}
                                    className="book-page-form-scan-rack-button"
                                >
                                    <Input placeholder="Enter / Scan Rack Shelf Barcode"></Input>
                                </Form.Item>
                                <Form.Item name="submit" hidden></Form.Item>
                                <button
                                    className="book-page-form-scan-rack-button-icon"
                                    htmlType="submit"
                                    onClick={(event) => {
                                        setDecodedResults([]);
                                        setActiveScanner("Rack & Shelf ID");
                                        cusfun(event);
                                    }}
                                >
                                    <svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <circle
                                            cx="12"
                                            cy="13"
                                            r="3"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                        />
                                        <path
                                            d="M18 10H17.5"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            opacity="0.5"
                                            d="M14.5 3.5H9.5"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                    <svg
                                        width="20"
                                        height="18"
                                        viewBox="0 0 20 18"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M6.00098 1C6.00098 0.447715 6.41425 0 6.92405 0H13.0779C13.5877 0 14.001 0.447715 14.001 1C14.001 1.55228 13.5877 2 13.0779 2H6.92405C6.41425 2 6.00098 1.55228 6.00098 1Z"
                                            fill="url(#paint0_linear_2146_40101)"
                                        />
                                        <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M7.77875 18H12.2232C15.3442 18 16.9047 18 18.0257 17.2777C18.511 16.965 18.9277 16.5632 19.252 16.0953C20.001 15.0143 20.001 13.5095 20.001 10.4999C20.001 7.49027 20.0008 5.9857 19.2518 4.90473C18.9275 4.43676 18.5109 4.03497 18.0256 3.72228C16.9046 3 15.3441 3 12.223 3H7.77859C4.65756 3 3.09705 3 1.97605 3.72228C1.49077 4.03497 1.0741 4.43676 0.749835 4.90473C0.000976503 5.98547 0.000976526 7.48961 0.000976563 10.4979L0.000976563 10.4999C0.000976563 13.5095 0.000976622 15.0143 0.750001 16.0953C1.07426 16.5632 1.49093 16.965 1.97622 17.2777C3.09721 18 4.65773 18 7.77875 18ZM5.83431 10.4999C5.83431 8.28085 7.69979 6.48196 10.001 6.48196C12.3022 6.48196 14.1676 8.28085 14.1676 10.4999C14.1676 12.7189 12.3022 14.5178 10.001 14.5178C7.69979 14.5178 5.83431 12.7189 5.83431 10.4999ZM7.50098 10.4999C7.50098 9.16846 8.62027 8.08913 10.001 8.08913C11.3817 8.08913 12.501 9.16846 12.501 10.4999C12.501 11.8313 11.3817 12.9106 10.001 12.9106C8.62027 12.9106 7.50098 11.8313 7.50098 10.4999ZM16.1121 6.48196C15.6519 6.48196 15.2788 6.84174 15.2788 7.28554C15.2788 7.72935 15.6519 8.08913 16.1121 8.08913H16.6676C17.1279 8.08913 17.501 7.72935 17.501 7.28554C17.501 6.84174 17.1279 6.48196 16.6676 6.48196H16.1121Z"
                                            fill="url(#paint1_linear_2146_40101)"
                                        />
                                        <defs>
                                            <linearGradient
                                                id="paint0_linear_2146_40101"
                                                x1="20.601"
                                                y1="8.95028"
                                                x2="-0.0170404"
                                                y2="11.3301"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stopColor="#033D9B" />
                                                <stop offset="1" stopColor="#29ACD5" />
                                            </linearGradient>
                                            <linearGradient
                                                id="paint1_linear_2146_40101"
                                                x1="20.601"
                                                y1="8.95028"
                                                x2="-0.0170404"
                                                y2="11.3301"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stopColor="#033D9B" />
                                                <stop offset="1" stopColor="#29ACD5" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </button>
                                <span className="error-msg-rad"></span>
                            </div>
                            <div className="modal-footer">
                                <Form.Item className="model-action-container">
                                    <Space style={{ marginRight: "20px" }}>
                                        { }
                                        <div className="modal-footer">
                                            <button
                                                className="modal-cancel-button"
                                                type="button"
                                                onClick={handleClear}
                                            >
                                                Clear
                                            </button>
                                            <button
                                                className="accept-button"
                                                htmlType="submit"
                                                onClick={() => handleClientQueueReject}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </Space>
                                </Form.Item>
                            </div>
                        </Form>
                    )}
                </div>
            </Drawer>

            <Modal
                title={`Scan ${activeScanner ? activeScanner : ""}`}
                open={!!activeScanner}
                onCancel={() => {
                    setActiveScanner(null);
                    isProcessingRef.current = false;
                }}
                footer={null}
                destroyOnClose
                className="scan-model-container"
                width={1000}
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={30}
                        qrbox={{ width: 1000, height: 400 }}
                        aspectRatio={2.8}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <main className="book-page-main-container">
                <div className="book-page-container">
                    <div className="book-page-title-container no-padding-right">
                        <div className="book-page-title">
                            <span></span>
                            <h2>BID Confirmation</h2>
                        </div>
                    </div>
                    <div className="book-page-form exception-form">
                        <div className="book-page-camera-button-container multiple w-100">
                            <Input
                                placeholder=""
                                value={form.rackId}
                                className=""                                
                                onChange={(e) => {
                                    setForm({ ...form, rackId: e.target.value });
                                }}
                                onKeyDown={(e) => {
                                    if (!isReadOnly("recyclebinId")) {
                                        return;
                                    }

                                    // Let native copy/paste behave normally (no custom clipboard handling).
                                    const isCopyOrPasteShortcut =
                                        (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
                                    if (isCopyOrPasteShortcut) {
                                        return;
                                    }

                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                        return;
                                    }

                                    const currentTime = Date.now();
                                    const timeDiff = currentTime - lastRackIdKeyTimeRef.current;
                                    lastRackIdKeyTimeRef.current = currentTime;

                                    // A physical scanner sends characters within a few milliseconds of each
                                    // other, so only block keystrokes that arrive slowly (manual typing).
                                    // The very first keystroke (field currently empty) is always let through
                                    // so a scan burst never loses its first character.
                                    const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
                                    if (!isSlowManualKeystroke) {
                                        return;
                                    }

                                    e.preventDefault();
                                    setForm((prev) => ({ ...prev, rackId: '' }));

                                    clearTimeout(clearRackIdTimerRef.current);
                                    clearRackIdTimerRef.current = setTimeout(() => {
                                        showManualEntryDisabledWarning();
                                    }, 300);
                                }}
                                onBlur={() => {
                                    if (isReadOnly("recyclebinId")) return;
                                }}
                            />
                            {form.rackId.length === 0 && (
                                <label htmlFor="cutting-batch-bid-input-id">
                                {isReadOnly("recyclebinId") ? "Scan " : "Enter / Scan "}Recycle Bin ID using “<strong>Camera Icon</strong>”
                                    <span className="form-required">*</span>
                                </label>
                            )}
                            <button
                                type="button"
                                className="book-page-camera-button"
                                onClick={() => { setDecodedResults([]); setActiveScanner("Recycle Bin ID"); }}
                                data-track="BidConfirmation-open-recycleBinId-scanner"
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg
                                    width="20"
                                    height="18"
                                    viewBox="0 0 20 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M6 1C6 0.447715 6.41328 0 6.92308 0H13.0769C13.5867 0 14 0.447715 14 1C14 1.55228 13.5867 2 13.0769 2H6.92308C6.41328 2 6 1.55228 6 1Z"
                                        fill="url(#paint0_linear_273_6915)"
                                    />
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M7.77778 18H12.2222C15.3433 18 16.9038 18 18.0248 17.2777C18.51 16.965 18.9267 16.5632 19.251 16.0953C20 15.0143 20 13.5095 20 10.4999C20 7.49027 19.9998 5.9857 19.2508 4.90473C18.9266 4.43676 18.5099 4.03497 18.0246 3.72228C16.9036 3 15.3431 3 12.2221 3H7.77761C4.65659 3 3.09607 3 1.97508 3.72228C1.48979 4.03497 1.07312 4.43676 0.748859 4.90473C-5.96046e-08 5.98547 -3.64038e-08 7.48961 0 10.4979L0 10.4999C0 13.5095 5.96046e-08 15.0143 0.749024 16.0953C1.07328 16.5632 1.48995 16.965 1.97524 17.2777C3.09624 18 4.65675 18 7.77778 18ZM5.83333 10.4999C5.83333 8.28085 7.69881 6.48196 10 6.48196C12.3012 6.48196 14.1667 8.28085 14.1667 10.4999C14.1667 12.7189 12.3012 14.5178 10 14.5178C7.69881 14.5178 5.83333 12.7189 5.83333 10.4999ZM7.5 10.4999C7.5 9.16846 8.61929 8.08913 10 8.08913C11.3807 8.08913 12.5 9.16846 12.5 10.4999C12.5 11.8313 11.3807 12.9106 10 12.9106C8.61929 12.9106 7.5 11.8313 7.5 10.4999ZM16.1111 6.48196C15.6509 6.48196 15.2778 6.84174 15.2778 7.28554C15.2778 7.72935 15.6509 8.08913 16.1111 8.08913H16.6667C17.1269 8.08913 17.5 7.72935 17.5 7.28554C17.5 6.84174 17.1269 6.48196 16.6667 6.48196H16.1111Z"
                                        fill="url(#paint1_linear_273_6915)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_273_6915"
                                            x1="20.6"
                                            y1="8.95028"
                                            x2="-0.0180169"
                                            y2="11.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stop-color="#033D9B" />
                                            <stop offset="1" stop-color="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_273_6915"
                                            x1="20.6"
                                            y1="8.95028"
                                            x2="-0.0180169"
                                            y2="11.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stop-color="#033D9B" />
                                            <stop offset="1" stop-color="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            { }
                        </div>
                        <div className="book-page-camera-button-container multiple w-100">
                            <Input
                                placeholder=""
                                value={form.bid}
                                className={`${form.bid ? "has-id" : ""}`}
                                onPressEnter={(e) => {
                                    if (isReadOnly("bid")) {
                                        e.preventDefault();
                                        return;
                                    }
                                    SubmitBidRecycle();
                                }}
                                onChange={(e) => {
                                    setForm({ ...form, bid: e.target.value });
                                }}
                                onKeyDown={(e) => {
                                    if (!isReadOnly("bid")) {
                                        return;
                                    }

                                    // Let native copy/paste behave normally (no custom clipboard handling).
                                    const isCopyOrPasteShortcut =
                                        (e.ctrlKey || e.metaKey) && ["c", "v", "C", "V"].includes(e.key);
                                    if (isCopyOrPasteShortcut) {
                                        return;
                                    }

                                    if (e.key === 'Enter' || e.key === 'Tab') {
                                        return;
                                    }

                                    const currentTime = Date.now();
                                    const timeDiff = currentTime - lastBidKeyTimeRef.current;
                                    lastBidKeyTimeRef.current = currentTime;

                                    // A physical scanner sends characters within a few milliseconds of each
                                    // other, so only block keystrokes that arrive slowly (manual typing).
                                    // The very first keystroke (field currently empty) is always let through
                                    // so a scan burst never loses its first character.
                                    const isSlowManualKeystroke = timeDiff > 50 && e.currentTarget.value.length > 0;
                                    if (!isSlowManualKeystroke) {
                                        return;
                                    }

                                    e.preventDefault();
                                    setForm((prev) => ({ ...prev, bid: '' }));

                                    clearTimeout(clearBidTimerRef.current);
                                    clearBidTimerRef.current = setTimeout(() => {
                                        showManualEntryDisabledWarning();
                                    }, 300);
                                }}
                                onBlur={() => {
                                    if (isReadOnly("bid")) return;
                                }}
                            />
                            {form.bid.length === 0 && (
                                <label htmlFor="cutting-batch-bid-input-id">
                                    {isReadOnly("bid") ? "Scan " : "Enter / Scan "}Book ID (BID) using “<strong>Camera Icon</strong>”
                                    <span className="form-required">*</span>
                                </label>
                            )}
                            <button
                                type="button"
                                className="book-page-camera-button"
                                onClick={() => { setDecodedResults([]); setActiveScanner("BID"); }}
                                data-track="BidConfirmation-open-bid-scanner"
                            >
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <circle
                                        cx="12"
                                        cy="13"
                                        r="3"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M10 19.9999H14C16.8089 19.9999 18.2134 19.9999 19.2223 19.3258C19.659 19.0339 20.034 18.6589 20.3259 18.2222C21 17.2133 21 15.8088 21 12.9999C21 10.191 20.9999 8.78673 20.3257 7.77783C20.0339 7.34107 19.6589 6.96607 19.2221 6.67423C18.2132 6.00011 16.8088 6.00011 13.9999 6.00011H9.99985C7.19093 6.00011 5.78646 6.00011 4.77757 6.67423C4.34081 6.96607 3.96581 7.34107 3.67397 7.77783C3 8.7865 3 10.1903 3 12.998L3 12.9999C3 15.8088 3 17.2133 3.67412 18.2222C3.96596 18.6589 4.34096 19.0339 4.77772 19.3258C5.78661 19.9999 7.19108 19.9999 10 19.9999Z"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                    />
                                    <path
                                        d="M18 10H17.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        opacity="0.5"
                                        d="M14.5 3.5H9.5"
                                        stroke="#1C274C"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                        fill="url(#paint0_linear_273_6917)"
                                    />
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                        fill="url(#paint1_linear_273_6917)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_273_6917"
                                            x1="22.601"
                                            y1="11.9503"
                                            x2="1.98296"
                                            y2="14.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_273_6917"
                                            x1="22.601"
                                            y1="11.9503"
                                            x2="1.98296"
                                            y2="14.3301"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                            <button
                                type="button"
                                className="book-page-camera-button-input-2"
                                onClick={() => SubmitBidRecycle()}
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967C9.67678 6.76256 9.67678 7.23744 9.96967 7.53033L12.4393 10L9.96967 12.4697C9.67678 12.7626 9.67678 13.2374 9.96967 13.5303C10.2626 13.8232 10.7374 13.8232 11.0303 13.5303L14.0303 10.5303C14.3232 10.2374 14.3232 9.76256 14.0303 9.46967L11.0303 6.46967ZM5.96967 6.46967C6.26256 6.17678 6.73744 6.17678 7.03033 6.46967L10.0303 9.46967C10.3232 9.76256 10.3232 10.2374 10.0303 10.5303L7.03033 13.5303C6.73744 13.8232 6.26256 13.8232 5.96967 13.5303C5.67678 13.2374 5.67678 12.7626 5.96967 12.4697L8.43934 10L5.96967 7.53033C5.67678 7.23744 5.67678 6.76256 5.96967 6.46967Z"
                                        fill="url(#paint0_linear_1900_8687)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_1900_8687"
                                            x1="20.6"
                                            y1="9.94475"
                                            x2="-0.0696504"
                                            y2="12.0919"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#033D9B" />
                                            <stop offset="1" stopColor="#29ACD5" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </button>
                        </div>
                    </div>

                    { }
                    <div className="table-container reducedbottom-padding-1">
                        <div className="rounded-table-wrapper">
                            <Table
                                columns={columns}
                                loading={loading}
                                dataSource={data}
                                className="common-grid withScanner"
                                pagination={false}
                                scroll={{ x: "max-content", y: "calc(100vh - 390px)" }}
                                rowClassName={getRowClassName}
                                onChange={handleTableChange}
                            />
                        </div>
                    </div>
                    { }
                </div>
            </main>
        </>
    );
};
export default RecycleBidConfirmation;
